import { useState, type ReactNode } from 'react';
import { Col } from 'react-bootstrap';
import { Navigate, useSearchParams } from 'react-router';
import { appUrlParamName, ottParamName } from './ResetPassword.constants';
import ResetErrorState from './ResetErrorState';
import ResetPasswordSection from './ResetPasswordSection';
import ResetSuccessSection from './ResetSuccessSection';
import useResetLinkValidation from './useResetLinkValidation';
import { ViewLayoutWrapper } from '@/pages/_layouts/publicLayout/layoutDesktop/LayoutDesktop.styles';

const ResetPasswordLayoutWrap = ({ children }: { children: ReactNode }) => (
  <ViewLayoutWrapper>
    <Col sm={8} md={8} lg={7} xl={5}>
      {children}
    </Col>
  </ViewLayoutWrapper>
);

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const ott = searchParams.get(ottParamName) ?? undefined;
  const appUrl = searchParams.get(appUrlParamName);
  const [isCompleted, setIsCompleted] = useState(false);

  const { data, isLoading, isError } = useResetLinkValidation();

  if (!ott) {
    const target = appUrl
      ? `/forgot-password?${appUrlParamName}=${encodeURIComponent(appUrl)}`
      : '/forgot-password';
    return <Navigate to={target} replace />;
  }

  if (isCompleted) {
    return (
      <ResetPasswordLayoutWrap>
        <ResetSuccessSection />
      </ResetPasswordLayoutWrap>
    );
  }

  if (isError || data?.valid === false) {
    return (
      <ResetPasswordLayoutWrap>
        <ResetErrorState />
      </ResetPasswordLayoutWrap>
    );
  }

  if (!data || isLoading) {
    return (
      <ResetPasswordLayoutWrap>
        <div data-testid="reset-loading" />
      </ResetPasswordLayoutWrap>
    );
  }

  return (
    <ResetPasswordLayoutWrap>
      <ResetPasswordSection
        ott={ott}
        passwordRequirements={data.passwordRequirements}
        onCompleted={() => setIsCompleted(true)}
      />
    </ResetPasswordLayoutWrap>
  );
};

export default ResetPassword;
